export default __webpack_public_path__ + "static/media/arrow-red-down.c856fbfd.svg";